export function isMobile(size = '767') {
    return window.matchMedia(`(max-width:${size}px)`).matches;
} 